import {
    useEffect,
    useState
} from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import API from "../../services/api";
import toast from "react-hot-toast";

function EditRole() {

    const navigate = useNavigate();

    const { id } =
        useParams();

    const [loading,
        setLoading] =
        useState(false);

    const [form,
        setForm] =
        useState({
            role_name: "",
            description: "",
            status: "active"
        });

    useEffect(() => {

        loadRole();

    }, []);

    const loadRole =
        async () => {

            try {

                const res =
                    await API.get(
                        `/roles/${id}`
                    );

                setForm({
                    role_name:
                        res.data.role_name || "",

                    description:
                        res.data.description || "",

                    status:
                        res.data.status || "active"
                });

            } catch (err) {

                console.log(err);

                toast.error(
                    "Failed to load role"
                );

            }

        };

    const submit =
        async (e) => {

            e.preventDefault();

            try {

                setLoading(true);

                await API.put(
                    `/roles/${id}`,
                    form
                );

                toast.success(
                    "Role updated successfully"
                );

                navigate(
                    "/admin/roles"
                );

            } catch (err) {

                console.log(err);

                toast.error(
                    err.response?.data?.message ||
                    "Failed to update role"
                );

            } finally {

                setLoading(false);

            }

        };

    return (

        <div>

            <h1
                className="
                text-4xl
                font-bold
                mb-6
            "
            >
                Edit Role
            </h1>

            <form
                onSubmit={submit}
                className="
                bg-[#111]
                rounded-2xl
                p-6
                max-w-3xl
            "
            >

                <div className="mb-5">

                    <label
                        className="
                        block
                        mb-2
                        font-semibold
                    "
                    >
                        Role Name
                    </label>

                    <input
                        type="text"
                        required
                        value={form.role_name}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                role_name:
                                    e.target.value
                            })
                        }
                        className="
                        w-full
                        p-3
                        rounded-xl
                        bg-black
                        border
                        border-yellow-500/20
                        focus:border-yellow-500
                        outline-none
                    "
                    />

                </div>

                <div className="mb-5">

                    <label
                        className="
                        block
                        mb-2
                        font-semibold
                    "
                    >
                        Description
                    </label>

                    <textarea
                        rows="5"
                        value={form.description}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                description:
                                    e.target.value
                            })
                        }
                        className="
                        w-full
                        p-3
                        rounded-xl
                        bg-black
                        border
                        border-yellow-500/20
                        focus:border-yellow-500
                        outline-none
                    "
                    />

                </div>

                <div className="mb-8">

                    <label
                        className="
                        block
                        mb-2
                        font-semibold
                    "
                    >
                        Status
                    </label>

                    <select
                        value={form.status}
                        onChange={(e) =>
                            setForm({
                                ...form,
                                status:
                                    e.target.value
                            })
                        }
                        className="
                        w-full
                        p-3
                        rounded-xl
                        bg-black
                        border
                        border-yellow-500/20
                        focus:border-yellow-500
                        outline-none
                    "
                    >

                        <option value="active">
                            Active
                        </option>

                        <option value="inactive">
                            Inactive
                        </option>

                    </select>

                </div>

                <div
                    className="
                    flex
                    gap-3
                "
                >

                    <button
                        type="submit"
                        disabled={loading}
                        className="
                        bg-yellow-500
                        hover:bg-yellow-400
                        text-black
                        px-6
                        py-3
                        rounded-xl
                        font-semibold
                        disabled:opacity-50
                    "
                    >
                        {
                            loading
                                ? "Updating..."
                                : "Update Role"
                        }
                    </button>

                    <button
                        type="button"
                        onClick={() =>
                            navigate(
                                "/admin/roles"
                            )
                        }
                        className="
                        bg-gray-700
                        hover:bg-gray-600
                        px-6
                        py-3
                        rounded-xl
                    "
                    >
                        Cancel
                    </button>

                </div>

            </form>

        </div>

    );

}

export default EditRole;